import { FC, useMemo, useCallback, memo } from 'react'
import * as styles from 'components/features/socialFeed/FeedfilterPopup/FollowedPeopleItem.styl'
import { FeedUserUid } from 'interfaces/feed'
import { createPluralFormatter } from 'helpers/formatHelpers'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { PostFollowButton } from 'components/features/pfm/SegmentButton/PostFollowButton'
import { UserAvatar } from 'components/features/socialFeed/Avatar/UserAvatar'
import { createFeedUserSelector, feedAppSelector } from 'selectors/feedSelectors'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { toggleAuthorFollowingActionCreator } from 'actions/feedActions'

type FollowedPeopleItemProps = {
  userUid: FeedUserUid
}

const getPluralPosts = createPluralFormatter('post', 'posts')

export const FollowedPeopleItem: FC<FollowedPeopleItemProps> = memo((props) => {
  const { userUid } = props

  const feedUserSelector = useMemo(createFeedUserSelector, [])

  const user = useStoreSelector((state) => feedUserSelector(state, props))
  const feedApp = useStoreSelector(feedAppSelector)
  const isFollowLoading = feedApp.authorFollowingLoadingIds[userUid]
  const dispatch = useStoreDispatch()

  const handleToggleFollow = useCallback(() => {
    if (!user || isFollowLoading) {
      return
    }

    dispatch(toggleAuthorFollowingActionCreator.request({
      toFollow: !user.is_followed,
      uid: userUid,
    }))
  }, [dispatch, user, isFollowLoading, userUid])

  if (!user) {
    return null
  }

  const { username, posts_count, is_followed, peergroup } = user

  return (
    <div className={ styles.container }>
      <div className={ styles.avatar }>
        <UserAvatar
          userUid={ userUid }
          matchRatio={ peergroup && peergroup.match ? peergroup.match.ratio : 1 }
        />
      </div>

      <div className={ styles.nameSection }>
        <NavigationLink
          className={ styles.name }
          title={ username }
          to={{ anchor: 'feedauthor', id: username }}
        >
          { username }
        </NavigationLink>
        <div className={ styles.posts }>
          { posts_count } { getPluralPosts(posts_count) }
        </div>
      </div>

      <div className={ styles.follow }>
        <PostFollowButton
          pressed={ is_followed }
          onClick={ handleToggleFollow }
        />
      </div>
    </div>
  )
})
